// extracted by mini-css-extract-plugin
export default {"wrapper":"Jpe1FvVjsO","title":"ohSo8NhGka","section":"rMOit3noOC"};